export enum OnlineMatchesFeedback {
  DuplicateMatches = 'duplicate_matches',
  CareerChangerCv = 'career_changer_cv',
  ProfileDeleted = 'profile_deleted',
  NoOneYearQualification = 'no_one_year_training',
  NoTwoYearQualification = 'no_two_year_training',
  NoThreeYearQualification = 'no_three_year_training',
  NoLg1OrLg2 = 'no_lg1_or_lg2',
  No43Or53 = 'no_43_or_53',
  NoDriversLicense = 'no_drivers_license',
  NoVacancy = 'no_vacancy',
  NoAssistantNurseVacany = 'no_assistant_nurse_vacany',
  EmployerNeedsOnlyFemaleApplicants = 'only_female_applicants',
  EmployerNotLookingForAssistantNurses = 'employers_not_looking_for_assistant_nurse',
  NotPartnerAnymore = 'not_a_partner',
  MarginalEmployment = 'marginal_employment',
  NoBasicTrainingCertificate = 'no_training',
  QualificationNotAcceptedInGermany = 'invalid_qualification',
  NoVisa = 'no_visa',
  NotEnoughExperience = 'no_experience',
  NoHospitalExperience = 'no_hospital_experience',
  LookingForApprenticeship = 'only_aprenticeship',
  NoTrainingOrExperienceInCare = 'no_care_experience',
  HaveBetterMatchAlready = 'better_match',
  MatchAlreadySumbittedInternally = 'match_submitted_internally',
  AcceptedByAccident = 'accidental_accept',
  HaveOfflineMatchWithEmployer = 'have_offline_match',
  NoNightShifts = 'no_night_shifts',
  NoMotherServices = 'no_mother_services',
  RejectionByKam = 'rejection_by_kam',
  LanguageB1 = 'language_b1',
  WillingnessToTravel = 'willingness_to_travel',
  HoursDoNotFit = 'hours_do_not_fit',
  NoApk = 'no_apk',
  OtherMissingQualification = 'other_missing_qualification',
  NoSchoolCertificate = 'no_school_certificate',
  FollowUpWithCemUnresponsive = 'follow_up_with_cem_unresponsive',
}
